import React from "react";
import { Link, graphql } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";

const styles = {
  title: {
    marginBottom: `0px`,
    marginTop: `40px`,
    fontSize: `24px`,
    textTransform: `none`,
    lineHeight: `33px`,
    letterSpacing: `1px`,
    fontWeight: `500`,
  },
  text: {
    margin: `0px`,
    fontSize: `18px`,
    color: `#303030`,
  },
};

const About = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title;

  return (
    <Layout location={location} title={siteTitle}>
      <SEO title="About" />

      <div
        style={{
          backgroundColor: `#EBEBEB`,
          height: `70px`,
        }}
      >
        <div
          style={{
            fontSize: `36px`,
            fontFamily: "Amatic SC",
            lineHeight: `100px`,
            paddingLeft: `5%`,
          }}
        >
          {" "}
          About
        </div>
      </div>
      <div
        style={{
          width: `90%`,
          marginRight: `5%`,
          marginLeft: `5%`,
        }}
      >
        <h4 style={styles.title}>What’s this?</h4>
        <p style={styles.text}>
          A collection of words written or spoken by others which I happen to
          find interesting or, sometimes, love dearly.
        </p>
        <h4 style={styles.title}>Why the name Words cut deepest?</h4>
        <p style={styles.text}>
          Well it’s true isn’t it?
          <br />
          Words are the wool with which everything around us is woven.
        </p>
        <h4 style={styles.title}>Social Media?</h4>
        <p style={styles.text}>
          <a href="https://instagram.com/words.cut.deepest" target="blank">
            Instagram.
          </a>
        </p>
        <h4 style={styles.title}>Do you write?</h4>
        <p style={styles.text}>
          I mainly write on{" "}
          <a href="https://phunnyspirit.xyz" target="blank">
            phunnyspirit.xyz
          </a>{" "}
          <br />
          To see what I’ve written elsewhere go to{" "}
          <Link to={`/writing`}>/writing</Link> page
        </p>
        <h4 style={styles.title}>Who’s behind all this?</h4>
        <p style={styles.text}>
          Honestly just a mess of a person who like stories <br />
          <a href="https://instagram.com/iamtherealgd" target="blank">
            @iamtherealgd
          </a>
        </p>
      </div>
      <div style={{ marginBottom: `100px` }}></div>
    </Layout>
  );
};

export default About;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`;
